import styled from "styled-components";

export const TabsWrapper = styled.div`
  margin-top: 100px;
  display: flex;
  @media (max-width: 1000px) {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
  }
`;

export const TabPanel = styled.div`
  opacity: ${({ hidden }) => (hidden ? "0" : "1")};
`;

export const TabList = styled.div`
  @media (max-width: 1000px) {
    flex-direction: row;
    margin-right: 0px;
    margin-bottom: 40px;
    font-size: 14px;
  }
`;
/*------Tab 0-------*/

/*------Tab 1-------*/
export const FirstTabContentWrapper = styled.div`
  font-size: 16px;
  @media (max-width: 800px) {
    font-size: 10px;
  }
`;

export const TabOneTitle = styled.p`
  font-size: 16px;
  span {
    color: var(--main-color);
  }
`;

export const TabOneDate = styled.p`
  font-size: 12px;
  color: #919191;
  margin-top: 13px;
  margin-bottom: 30px;
`;

export const TabOneContent = styled.div`
  font-size: 14px;
  > * + * {
    margin-top: 15px;
  }
  @media (max-width: 800px) {
    font-size: 12px;
  }
`;

export const ViewCaseStudyButton = styled.button`
  all: unset;
  text-transform: capitalize;
  font-size: 16px;
  color: var(--main-color);
  border: solid 2px var(--main-color);
  padding: 14px;
  cursor: pointer;
  margin-top: 30px;
  margin-bottom: 30px;
  text-align: center;
  @media (max-width: 1100px) {
    font-size: 16px;
    padding: 12px;
  }
  @media (max-width: 600px) {
    /* font-size: 14px; */
    /* padding: 12px; */
  }
`;

/*------Tab 2-------*/
export const SecondTabContentWrapper = styled.div`
  font-size: 16px;
`;

export const TabTwoTitle = styled.p`
  font-size: 16px;
  span {
    color: var(--main-color);
  }
`;

export const TabTwoDate = styled.p`
  font-size: 12px;
  color: #919191;
  margin-top: 13px;
  margin-bottom: 30px;
`;

export const TabTwoContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  font-size: 14px;
  /* gap: 30px; */
  > * + * {
    margin-top: 15px;
  }
  @media (max-width: 800px) {
    font-size: 12px;
  }
`;
